import flatpickr from "flatpickr";
import { Instance } from "flatpickr/dist/types/instance";
import { Dom } from "../../../common/dom";
import { Helper } from "../../../common/helper";
import { Icon, IconHelper } from "../../../common/icon-helper";
import { EditControl } from "../../form-row";
import { DatePickerHelper } from "./date-picker-helper";

export class DateControl implements EditControl
{
    private readonly input: HTMLInputElement;
    private readonly inputRow: HTMLDivElement;
    private readonly dateGroup: HTMLDivElement;
    private fp: Instance;
    private readonly isNative: boolean;
    private onChangeAction = () =>
    {};

    constructor(placeholder?: string)
    {
        // On mobile we use the OS-native date input for the single date field;
        // everywhere else we use flatpickr to keep the DD.MM.YYYY look and feel.
        this.isNative = Helper.isMobile();

        this.inputRow = Dom.createDiv();
        this.input = Dom.create("input", "form-control", "w-date-picker-input");

        this.dateGroup = Dom.addDiv(this.inputRow, "input-group", "date", "w-date-picker-group");
        this.input.placeholder = placeholder || "";
        this.dateGroup.append(this.input);

        if (this.isNative)
        {
            this.input.type = "date";
            this.input.addEventListener("change", () => this.notifyChange());
            return;
        }

        this.input.type = "text";
        const addon = Dom.addSpan(this.dateGroup, "input-group-addon");
        Dom.addSpan(addon).className = IconHelper.getIconClass(Icon.Calendar);

        this.fp = flatpickr(this.input, {
            ...DatePickerHelper.baseOptions(),
            allowInput: true,
            onChange: () => this.notifyChange()
        });
        this.fp.calendarContainer.classList.add("w-date-picker");
        this.input.closest(".flatpickr-wrapper")?.classList.add("w-date-picker-wrapper");

        addon.addEventListener("click", () => this.fp.open());
    }

    initialize(parent: HTMLElement)
    {
        parent.append(this.inputRow);
    }

    async setValue(value: string)
    {
        if (this.isNative)
        {
            this.input.value = DatePickerHelper.toNative(value);
            return;
        }

        if (value)
        {
            this.fp.setDate(value, false);
        }
        else
        {
            this.fp.clear();
        }
    }

    getValue()
    {
        if (this.isNative)
        {
            return DatePickerHelper.fromNative(this.input.value);
        }

        const value = this.input.value;
        return value === "" ? null : value;
    }

    onChange(action: () => void)
    {
        this.onChangeAction = action;
    }

    focus()
    {
        this.input.focus();
    }

    private notifyChange()
    {
        if (this.onChangeAction)
        {
            this.onChangeAction();
        }
    }
}
